export const DATE_FORMAT = 'YYYY-MM-DD hh:mm a';
export const SESSION_DATE_FORMAT = 'ddd, MMM Do hh:mm a';
export const REVIEW_SESSION_DATE_FORMAT = 'Do h:mm a';